import { render, staticRenderFns } from "./activityCourseMaterial.html?vue&type=template&id=7a801199&scoped=true&external"
import script from "./activityCourseMaterial.vue?vue&type=script&lang=js"
export * from "./activityCourseMaterial.vue?vue&type=script&lang=js"
import style0 from "./activityCourseMaterial.css?vue&type=style&index=0&id=7a801199&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a801199",
  null
  
)

export default component.exports